/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { createSlice } from "@reduxjs/toolkit";
import { TOPOLOGY_ROOM } from "../../../rooms/RoomNameConstants";
import TopologyRoomInitState from "../../../rooms/TopologyRoom/state";

const initialState = { ...TopologyRoomInitState };

const topologyRoomSlice = createSlice({
    name: TOPOLOGY_ROOM,
    initialState: initialState,
    reducers: {
        setTopologyGraphData: (state, action) => {
            let { nodes, links } = action.payload

            links.forEach((link) => {
                const sourceStatus = nodes.find((node) => node.id === link.source).status
                const targetStatus = nodes.find((node) => node.id === link.target).status

                link.color = sourceStatus === "Successful" && targetStatus !== "Successful" ? "#fffff0" : "white"
            })

            state.graph.data = action.payload
        },
        setPollingDelay: (state, action) => {
            const p = action.payload
            state.graph.pollingDelay = p === 'none' ? p : parseInt(p)
        },
        setTopologyGraphFilter: (state, action) => {
            state.graph.filter = action.payload
        },
        setCurrentHoverElement: (state, action) => {
            const { isSelected, ...rest } = action.payload
            state.graph.currentHoverElement = rest
        },
        leaveCurrentHoverElement: (state) => {
            state.graph.currentHoverElement = null
        },
        setPosition: (state, action) => {
            Object.assign(state.graph.state.position, action.payload)
        },
        setZoom: (state, action) => {
            state.graph.state.scale = action.payload
        },
        resetInitialTopologyRoom: (state) => {
            Object.assign(state, initialState)
        },
        laodRemoteTopologyRoom: (state, action) => {
            Object.assign(state, action.payload)
        }
    }
});

export const {
    leaveCurrentHoverElement,
    setCurrentHoverElement,
    laodRemoteTopologyRoom,
    resetInitialTopologyRoom,
    setTopologyGraphData,
    setTopologyGraphFilter,
    setPollingDelay,
    setPosition,
    setZoom,
} = topologyRoomSlice.actions;

export default topologyRoomSlice;
